import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const EmailIcon = ({
  color = colors.black,
  className,
  onClick,
  size = 16,
  style,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
      style={style}
    >
      <path
        d="M10.6699 9.09991C9.06063 10.1906 6.94917 10.1905 5.33984 9.09991L6.18164 7.85773C7.28282 8.60399 8.72698 8.60406 9.82812 7.85773L10.6699 9.09991ZM3.17773 5.82159L6.18164 7.85773L5.33984 9.09991L2.33594 7.06281L2.75684 6.44171L3.17676 5.82062L3.17773 5.82159ZM1.25977 5.03351C1.26002 3.68034 2.35679 2.58357 3.70996 2.58331H12.2988C13.6525 2.58331 14.7499 3.68054 14.75 5.03448C14.75 5.84676 14.3467 6.60599 13.6729 7.06183L13.6738 7.06281L10.6699 9.09991L9.82812 7.85773L12.832 5.82159L12.833 5.82062L12.9258 5.74933C13.1302 5.57065 13.25 5.31059 13.25 5.03448C13.2499 4.50858 12.8237 4.08331 12.2988 4.08331H3.70996C3.18522 4.08357 2.76002 4.50876 2.75977 5.03351C2.75977 5.34873 2.91581 5.64356 3.17676 5.82062L2.33594 7.06281C1.66251 6.60649 1.25977 5.84609 1.25977 5.03351Z"
        fill={color}
      />
      <path
        d="M1.25 11.3338V5.03398C1.25 4.61977 1.58579 4.28398 2 4.28398C2.41421 4.28398 2.75 4.61977 2.75 5.03398V11.3338C2.75025 12.024 3.3097 12.5838 4 12.5838H12C12.6903 12.5838 13.2497 12.024 13.25 11.3338V5.03448C13.25 4.62027 13.5858 4.28496 14 4.28496C14.4142 4.28496 14.75 4.62027 14.75 5.03448V11.3338C14.7497 12.8524 13.5187 14.0838 12 14.0838H4C2.48128 14.0838 1.25025 12.8524 1.25 11.3338Z"
        fill={color}
      />
    </svg>
  );
};

export default EmailIcon;
